.flare-settings-management {
  --flare-management-row-gap: 12px;
  box-sizing: border-box;
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  overflow: auto;
  padding: 28px clamp(16px, 4%, 46px);
}

.flare-settings-management-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 16px;
}

.flare-settings-management-title {
  font-size: 22px;
  font-weight: 500;
  margin: 0;
}

.flare-settings-management > .flare-skill-management {
  flex: none;
  overflow: visible;
  height: auto;
  min-height: 0;
  padding: 0;
}

.flare-skill-management-controls,
.flare-skill-view-switcher {
  align-items: center;
  display: flex;
  gap: 12px;
}

.flare-skill-view-switcher {
  border: 1px solid var(--flare-divider, #e5e7eb);
  border-radius: 8px;
  flex-shrink: 0;
  gap: 2px;
  padding: 2px;
}

.flare-skill-view-switcher button {
  color: var(--flare-text-secondary, #64748b);
}

.flare-skill-view-switcher button[aria-pressed="true"] {
  background: var(--flare-hover-bg, rgba(37, 99, 235, 0.08));
  color: var(--flare-primary, #2563eb);
}

.flare-skill-view-switcher button:focus-visible {
  outline: 2px solid var(--flare-primary, #2563eb);
  outline-offset: 2px;
}

.flare-skill-management-list.is-grid {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(auto-fill, minmax(min(240px, 100%), 1fr));
  padding: 16px 0;
}

.flare-settings-management .flare-skill-management-row {
  gap: var(--flare-management-row-gap);
}

.flare-skill-management-list.is-grid .flare-skill-management-row,
.flare-mode-management .is-grid .flare-mode-management-row {
  border: 1px solid var(--flare-divider, #e5e7eb);
  border-radius: 12px;
  grid-template-columns: minmax(0, 1fr) auto 16px;
  grid-template-rows: 48px minmax(44px, auto) auto;
  padding: 16px;
}

.is-grid .flare-skill-management-icon {
  font-size: 24px;
  grid-column: 1 / -1;
  height: 48px;
  width: 48px;
}

.is-grid .flare-skill-management-copy {
  align-self: start;
  grid-column: 1 / -1;
}

.flare-mode-management .is-grid .flare-skill-toggle {
  grid-column: 2;
}

@media (max-width: 720px) {
  .flare-settings-management {
    padding: 18px 16px;
  }

  .flare-settings-management .flare-skill-management-header {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
    padding-bottom: 12px;
  }

  .flare-skill-management-controls {
    align-self: flex-end;
  }
}

.flare-mode-management { margin-bottom: 32px; }
.flare-mode-management-row {
  align-items: center;
  border-bottom: 1px solid var(--flare-divider, #e5e7eb);
  display: grid;
  gap: var(--flare-management-row-gap);
  grid-template-columns: 32px minmax(0, 1fr) auto 16px;
  min-height: 58px;
  padding: 4px 8px;
}
